module.exports = __webpack_public_path__ + "img/dingweixiaoding3.prt.9bdf2aa4.jpg";